import {
    Box,
    Typography,
    Button,
    Stack,
    Link,
    Grid,
    Paper,
} from "@mui/material";

import { useNavigate } from "react-router-dom";
import OpenSV from "../assets/opensv.png";
import { LAST_OPEN_DATES, NEXT_OPEN_DATES } from "../constants/Open";
// import { useState } from "react";

export default function Agenda() {
    const navigate = useNavigate();
    // const [mode, setMode] = useState<"new" | "existing" | null>(null);
    // const [accepted, setAccepted] = useState(false);
    // const [code, setCode] = useState("");
    // const [dialogOpen, setDialogOpen] = useState(false);
    
    return (
        <Box
            sx={{
                maxWidth: 900,
                mx: "auto",
                px: 3,
                py: 4,
                textAlign: "center",
            }}
        >
            <Box
                component="img"
                src={OpenSV}
                alt="Open International de Sambreville"
                sx={{
                    width: {
                        xs: 220,
                        md: 350,
                    },
                    maxWidth: "100%",
                    mb: 4,
                }}
            />

            <Typography
                variant="h4"
                fontWeight="bold"
                gutterBottom
            >
                Prochain Open
            </Typography>

            <Typography
                variant="h6"
                gutterBottom
            >
                {NEXT_OPEN_DATES}
            </Typography>
            <Typography variant="h4" gutterBottom>
                <Button
                    variant="outlined"
                    component={Link}
                    onClick={() => navigate("/registration")}
                    target="_blank"
                >
                    S'inscrire à l'Open
                </Button>

            </Typography>

            {/* <Typography
        variant=000",
        }}
        onClick={() => navigate("/inscriptions")}
      >
        S'inscrire à l'Open
      </Button> */}

            <Typography
                variant="h4"
                fontWeight="bold"
                gutterBottom
            >
                Dernier Open
            </Typography>

            <Typography
                variant="h6"
                gutterBottom
            >
                {LAST_OPEN_DATES}
            </Typography>

            <Grid container spacing={2} justifyContent="center">
                <Grid>
                    <Paper sx={{ p: 3, textAlign: "center" }}>
                        <Typography variant="h3" fontWeight="bold">
                            720
                        </Typography>
                        <Typography>
                            Judokas
                        </Typography>
                    </Paper>
                </Grid>

                <Grid>
                    <Paper sx={{ p: 3, textAlign: "center" }}>
                        <Typography variant="h3" fontWeight="bold">
                            7
                        </Typography>
                        <Typography>
                            Pays
                        </Typography>
                    </Paper>
                </Grid>
            </Grid>

            <Stack
                direction={{
                    xs: "column",
                    sm: "row",
                }}
                spacing={2}
                justifyContent="center"
                sx={{ mt: 3 }}
            >
                <Button
                    variant="outlined"
                    component={Link}
                    href="https://judoclubsambreville.be/index.php/open-jc-sambreville-2026-les-resultats/"
                    target="_blank"
                >
                    Résultats
                </Button>
                <Button
                    variant="outlined"
                    component={Link}
                    href="https://photos.google.com/share/AF1QipOZAIl1khas9frzoqMILyVp5n1XHV3YEpvAhHjhzAT6ZxabyjKGjocY-gfS4Gn5Qw?key=V1MzanN1azBKZHNoTjNqZF9pSTFiVXgydGVvR2xR"
                    target="_blank">
                    Photos
                </Button>
                {/* <Button 
        // khas9frzoqMILyVp5n1XHV3YEpvAhHjhzAT6ZxabyjKGjocY-gfS4Gn5Qw?key=V1MzanN1azBKZHNoTjNqZF9pSTFiVXgydGVvR2xR"
          target="_blank"
        >
          Photos
        </Button> */}
            </Stack>
        </Box>
    );
}